import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import { AuthLoginInfo } from "../AuthComponents/AuthLogin";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function BannerPage() {
  const [orderData, setOrderData] = useState([]);
  const [buttonPopup, setButtonPopup] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [newOrderSubmitted, setNewOrderSubmitted] = useState(false);
  const [bannerDetails, setBannerDetails] = useState({
    groupName: "",
    bannerWidth: 100,
    bannerHeight: 100,
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterOrders, setFilterOrders] = useState("");

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const totalOrders = filteredData.length;
  const computedOrders = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const addNewBanner = () => {
    const token = localStorage.getItem('token');
    console.log('bannerDetails', bannerDetails);
    axios
      .post(
        `${config.apiEndpoint}/AdsGroup`,
        {
          groupName: bannerDetails.groupName,
          bannerWidth: bannerDetails.bannerWidth,
          bannerHeight: bannerDetails.bannerHeight,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201  ) {
          setBannerDetails({
            groupName: "",
            bannerWidth: 100,
            bannerHeight: 100,
          });
          console.log("New banner added successfully");
          setButtonPopup(false);
          setNewOrderSubmitted(!newOrderSubmitted); // Toggle to trigger useEffect
        }
      })
      .catch((err) => {
        console.error("Error adding new banner:", err);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/AdsGroup`, { headers: { Authorization: `Bearer ${token}` }, withCredentials: true })
      .then(res => {
        console.log('orderData', res.data);
        setOrderData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching banners:", err);
      });
  }, [newOrderSubmitted]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Banners</h1>
          <Pagination
            total={totalOrders}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterOrders("");
                    setFilterActive(1);
                  }}
                >
                  All banners
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={orderData}
                handleSearchChange={handleSearchChange}
                dataType="banner"
                status={filterOrders}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>Banner ID</th>
                  <th>Banner name</th>
                  <th>Width</th>
                  <th>Height</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedOrders.map((banner) => {
                  return (
                    <tr key={banner.id}>
                      <td>
                        <font className="maincolor">#</font>
                        {banner.id}
                      </td>
                      <td>{banner.groupName}</td>
                      <td>{banner.bannerWidth}</td>
                      <td>{banner.bannerHeight}</td>
                      <td className="maincolor">
                        <button
                          onClick={() => {
                            const token = localStorage.getItem('token');
                            axios
                              .delete(`${config.apiEndpoint}/AdsGroup/${banner.id}`, {
                                headers: { Authorization: `Bearer ${token}` },
                                withCredentials: true,
                              })
                              .then((res) => {
                                if (res.status === 204) {
                                  setNewOrderSubmitted(!newOrderSubmitted); // Toggle to trigger useEffect
                                  console.log("Banner removed successfully");
                                }
                              })
                              .catch((err) => {
                                console.error("Error removing banner:", err);
                              });
                          }}
                        >
                          <RemoveRoundedIcon />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Popup trigger={buttonPopup} setTrigger={setButtonPopup}>
        <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new banner</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Banner name"
                    className="orderDetailsInput"
                    value={bannerDetails.groupName}
                    onChange={(e) =>
                      setBannerDetails({
                        ...bannerDetails,
                        groupName: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <select
                    className="orderDetailsInput"
                    value={bannerDetails.bannerWidth}
                    onChange={(e) =>
                      setBannerDetails({
                        ...bannerDetails,
                        bannerWidth: Number(e.target.value),
                      })
                    }
                    required="required"
                  >
                    <option value="">Select Banner Width</option>
                    {Array.from({ length: 11 }, (_, i) => 100 + i * 20).map((width) => (
                      <option key={width} value={width}>
                        {width} px
                      </option>
                    ))}
                  </select>
                </div>
                <div className="input-group">
                  <select
                    className="orderDetailsInput"
                    value={bannerDetails.bannerHeight}
                    onChange={(e) =>
                      setBannerDetails({
                        ...bannerDetails,
                        bannerHeight: Number(e.target.value),
                      })
                    }
                    required="required"
                  >
                    <option value="">Select Banner Height</option>
                    {Array.from({ length: 11 }, (_, i) => 100 + i * 20).map((height) => (
                      <option key={height} value={height}>
                        {height}px
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewBanner()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default BannerPage;